import AdvisoryServices from 'Components/AdvisoryServices/AdvisoryServices';
import Footer from 'Components/Home/Footer';
import Navbar from 'Components/Home/Navbar';
import MainHeadingSub from 'Components/MainHeading/MainHeadingSub';
import OperationalServices from 'Components/OperationsServices/OperationalServices';
import Summary from 'Components/Summary/Summary';
import React, { useEffect } from 'react';
import solutionsImg from 'Assets/elvotaimages/Heading/solutionsImg.jpg';
import evoltaComputerIllustration from 'Assets/elvotaimages/evolta_computer_illustration.png';
import FooterTop from 'Components/FooterTop/FooterTop';
import { useLocation } from 'react-router-dom';

export default function Solutions() {
  const location = useLocation();
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)); // Remove the '#' and get the element by ID
      if (element) {
        // Get the element's position relative to the page
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offset = 0; // Adjust this value to control the padding from the top (e.g., height of navbar)
        // Scroll to the element with an offset
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });
      }
    }
  }, [location]);

  const content = [
    'At Evolta Technologies, we offer two powerful solutions designed to unlock the full potential of your energy storage assets. Our advanced AI-driven platform ensures real-time optimization, maximizing profitability and performance for battery energy storage systems (BESS). Alongside this, our advisory service delivers expert insights and long-term forecasting to guide BESS project development, helping you make strategic decisions with confidence.',
    'Explore how Evolta’s innovative technology and deep industry expertise can help you succeed in an evolving energy market, no matter where your project is located.',
  ];
  return (
    <div>
      <Navbar />
      <MainHeadingSub
        simple="Transforming Energy Storage with "
        highlighted="Innovative Solutions"
        imageSrc={`linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${solutionsImg})`}
      />
      <div className="main-container">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-8">
            <Summary paragraph={content} />
          </div>
          <div className="col-span-12 md:col-span-4 flex items-center justify-center xl:p-10">
            {' '}
            <img
              src={evoltaComputerIllustration}
              className="w-full h-auto max-w-[320px]"
              alt="Evolta Computer Illustration"
            />
          </div>
        </div>
      </div>
      <div id="operational_services" className="main-container">
        <OperationalServices />
      </div>
      <div id="advisory_services" className="additional-bg">
        <div className="main-container lg:pb-[250px] pb-[150px]">
          <AdvisoryServices />
        </div>
      </div>
      <FooterTop />
      <Footer />
    </div>
  );
}
